import _ from 'lodash';
riot.tag2('raq-select-vehicle', '<div class="raq-select-vehicle-container"> <p class="raq-select-vehicle-model-title acr-caption-6">{labels.vehicleSelector.model}</p> <ul class="raq-select-vehicle-ctas acr-paragraph-8 {state} {\'top-options\': options === topOptions}"> <li each="{tab in tabs}" class="raq-select-vehicle-cta {\'is-active\': tab.selected}"> <button class="raq-select-vehicle-cta__button {\'is-active\': tab.selected}" show="{options === topOptions}" onclick="{selectTab}" onsubmit="{selectTab}" onkeypress="{selectTab}" data-tracking="{trakingHandler.selectVehicleCta(tab.name)}"> {tab.name} </button> </li> <li class="raq-select-vehicle-cta" show="{options !== topOptions}" onclick="{goBack}"><span class="selector-title-cta__text">{labels.vehicleSelector.back}</span></li> <li class="raq-select-vehicle-cta" show="{state === \'selected\'}" onclick="{goTop}"><span class="selector-title-cta__text">{labels.vehicleSelector.edit}</span></li> </ul> <div id="modelDropdown" class="raq-select-vehicle-dropdown {\'is-expanded\': isModelOpen} {\'raq-required-field\': modelNotSelected}"> <div class="selector-header"> <button class="selector-title-cta acr-caption-10" onclick="{toggleModelDropdown}" onkeypress="{toggleModelDropdown}" onsubmit="{selectModel}" type="button" data-tracking="{trackingFilteringModelData}"> <span class selector-title-cta__heading>{dropdownModelTitle}</span> <acr-svg svg-id="cta-arrow-down" svg-focusable="false" svg-class="acr-icon selector-dropdown-icon" svg-viewbox="0 0 26 26"></acr-svg> </button> </div> <div class="selector-dropdown"> <ul class="selector-dropdown-container {\'is-open\': isModelOpen}"> <li class="acr-paragraph-5" each="{option, index in options}"> <button class="selector-item" tabindex="0" focusable="true" onkeypress="{selectModel}" onclick="{selectModel}" onsubmit="{selectModel}" id="{option.id}" opt-index="{index}" data-tracking="{trakingHandler.modelSelectorFilter(option.name)}">{option.name} </button> </li> </ul> </div> <span class="selector-dropdown-required-label acr-paragraph-8">{labels.vehicleSelector.modelError}</span> </div> <p class="raq-select-vehicle-package-title acr-caption-6">{labels.vehicleSelector.package}</p> <div id="raq-package-selector-dropdown" class="raq-select-vehicle-dropdown {\'is-expanded\': isPackageOpen} {\'raq-select-vehicle-dropdown--disabled\': packageDisabled} {\'raq-required-field\': packageNotSelected}" required="true"> <div class="selector-header"> <button class="selector-title-cta acr-caption-10" onclick="{togglePackageDropdown}" type="button" disabled="{packageDisabled}" data-tracking="{trackingFilteringPackageData}"> <span class selector-title-cta__heading>{dropdownPackageTitle}</span> <acr-svg svg-id="cta-arrow-down" svg-focusable="false" svg-class="acr-icon selector-dropdown-icon" svg-viewbox="0 0 26 26"></acr-svg> </button> </div> <div class="selector-dropdown"> <ul class="selector-dropdown-container {\'is-open\': isPackageOpen}"> <li class="acr-paragraph-5 " each="{package, index in packages}"> <button class="selector-item" tabindex="0" focusable="true" onclick="{selectPackage}" onkeypress="{selectPackage}" onsubmit="{selectPackage}" opt-index="{index}" data-tracking="{trakingHandler.packageSelectorFilter(selectedVehicle.name, package.packageName)}"> {package.packageName} </button> </li> </ul> </div> <span class="selector-dropdown-required-label acr-paragraph-8">{labels.vehicleSelector.packageError}</span> </div> </div> <div class="raq-vehicle-image {\'raq-vehicle-image--disabled\': isImageDisabled}"> <div class="raq-vehicle-image__text"> <p class="raq-vehicle-image__model"><span class="acr-secondary-title-1">{selectedVehicle.modelYear}</span> <span class="acr-caption-3">{selectedVehicle.modelSeries}</span></p> <p class="raq-vehicle-image__package acr-paragraph-4">{packageDescription}</p> </div> <div class="raq-vehicle-image__img-container"> <img riot-src="{vehicleImage}" alt="{vehicleImageAlt}"> </div> </div>', '', 'class="raq-select-vehicle"', function(opts) {

    const self = this;
    const TAXONOMY = require('../../core/platform/constants').default.taxonomy;
    const params = require('../../core/params');
    const modelLabel = window.raq.labels.vehicleSelector.model;
    const packageLabel = window.raq.labels.vehicleSelector.package;
    const undecidedPackageLabel = window.raq.labels.vehicleSelector.undecided;
    const ghostImage = window.raq.ghostImage;
    const ghostImageAlt = window.raq.ghostImageAlt;
    const $modelDropdownId = '#modelDropdown';
    const $packageDropdownId = '#raq-package-selector-dropdown';
    self.trakingHandler = require('../../core/trackingManager');

    let vehicleSelected = false;
    let packageSelected = false;

    this.mixin('bus');
    self.vehicles = 'currentVehicles';
    self.state = TAXONOMY.defaultState;
    self.prevOptions = [];
    self.tabs = [];
    self.options = [];
    self.isModelOpen = false;
    self.isPackageOpen = false;
    self.packageDisabled = true;
    self.packages = [];
    self.dropdownModelTitle = modelLabel;
    self.dropdownPackageTitle = packageLabel;
    self.selectedVehicle = {};
    self.packageDescription = '';
    self.vehicleImage = '';
    self.vehicleImageAlt = '';
    self.isImageDisabled = true;
    self.modelNotSelected = false;
    self.packageNotSelected = false;

    function updateState() {
      self.bus.trigger(self.bus.EVENTS.VEHICLE.STATE_UPDATED, {
        state: self.state,
      });
    }

    updateState();

    function updateOptions(option) {
      const options = [];
      option.forEach((op) => {
        const opObj = {};
        opObj.name = op[TAXONOMY.name];
        opObj.options = op[TAXONOMY.vehicles] && op[TAXONOMY.vehicles].length > 0 ? updateOptions(op[TAXONOMY.vehicles]) : null;
        if (op[TAXONOMY.vehicle]) {
          opObj.modelYear = op[TAXONOMY.year];
          opObj.modelSeries = op[TAXONOMY.vehicle];
          opObj.vehicleImage = op[TAXONOMY.vehicleImage];
          opObj.vehicleImageAlt = op[TAXONOMY.vehicleImageAlt];
          opObj.packages = op[TAXONOMY.packages] && op[TAXONOMY.packages].length > 0 ? updatePackages(op[TAXONOMY.packages], op[TAXONOMY.vehicleImage], op[TAXONOMY.vehicleImageAlt]) : null;
          opObj.type = TAXONOMY.vehicleType;
        } else {
          opObj.type = TAXONOMY.categoryType;
        }
        options.push(opObj);
      });
      return options;
    }

    // This function updates the packages object for each vehicle
    function updatePackages(pPackages, pVehicleImage, pVehicleImageAlt) {
      const packages = [];
      const undecidedPackage = {};
      pPackages.forEach((vPackage) => {
        const packagesObj = {};
        packagesObj.packageName = vPackage[TAXONOMY.packageName];
        packagesObj.packageDescription = vPackage[TAXONOMY.packageDescription];
        packagesObj.packageImage = vPackage[TAXONOMY.packageImage];
        packagesObj.packageImageAlt = vPackage[TAXONOMY.packageImageAlt];
        packagesObj.modelId = vPackage[TAXONOMY.modelId];
        packages.push(packagesObj);
      });
      undecidedPackage.packageName = undecidedPackageLabel;
      undecidedPackage.packageDescription = '';
      undecidedPackage.packageImage = pVehicleImage;
      undecidedPackage.packageImageAlt = pVehicleImageAlt;
      undecidedPackage.modelId = undecidedPackageLabel;
      packages.push(undecidedPackage);

      return packages;
    }

    function addOptionsID(taxonomyName, optionsList) {
      const optionsWithID = [];
      _.forEach(optionsList, (op) => {
        const opObj = op;
        opObj.id = `raq-${taxonomyName.split(' ')[0].toLowerCase()}-${opObj.modelSeries}`;
        optionsWithID.push(opObj);
      });
      return optionsWithID;
    }

    function getTabs(data, tabIndex) {
      const tabs = [];
      data.forEach((op) => {
        const opObj = {};
        opObj.name = op[TAXONOMY.name];
        opObj.subNode = op[TAXONOMY.vehicles];
        opObj.options = opObj.subNode ? updateOptions(opObj.subNode) : null;
        opObj.selected = false;
        tabs.push(opObj);
      });

      self.tabs = tabs;
      if (self.tabs) { // Selecting the tab based on the index
        self.tabs[tabIndex].selected = true;
        self.options = self.tabs[tabIndex].options ? addOptionsID(self.tabs[tabIndex].name, self.tabs[tabIndex].options) : [];
        self.vehicleImage = ghostImage;
        self.vehicleImageAlt = ghostImageAlt;
      }
      self.topOptions = self.options;
      self.update();
    }

    function selectTab(e) {
      const target = _.find(self.tabs, { name: e.item.tab.name });
      _.forEach(self.tabs, (tab, key) => {
        self.tabs[key].selected = false;
      });
      target.selected = true;
      self.options = target.options ? addOptionsID(target.name, target.options) : [];
      self.topOptions = self.options;
    }

    // Reset the view data when the user changes the tab
    function resetViewData() {
      self.isModelOpen = false;
      self.isPackageOpen = false;
      self.dropdownModelTitle = modelLabel;
      self.dropdownPackageTitle = packageLabel;
      self.packageDisabled = true;
      self.vehicleImage = ghostImage;
      self.vehicleImageAlt = ghostImageAlt;
      self.isImageDisabled = true;
      self.bus.trigger(self.bus.EVENTS.VEHICLE.RESET);
    }

    // Function that is triggered when the user selects a model from the dropdown
    function selectModel(e) {
      self.bus.trigger(self.bus.EVENTS.VEHICLE.RESET, e);
      const option = e.item.option;
      const options = option.options;
      if (options) {
        self.prevOptions.push(self.options);
        self.options = options;
        self.state = TAXONOMY.modelsState;
        toggleModelDropdown();
        updateState();
      } else {
        toggleModelDropdown();
        updateSelectedModelInfo(option);
      }
      document.removeEventListener('click', closeModelDropdown);
      document.removeEventListener('keydown', closeModelDropdown);
    }

    // Update the information displayed in the "select a vehicle" section
    function updateSelectedModelInfo(option) {
      self.dropdownModelTitle = option.name;
      self.vehicleImage = option.vehicleImage;
      self.vehicleImageAlt = option.vehicleImageAlt;
      self.isModelOpen = false;
      updatePackageDropdown(option.packages);
      self.selectedVehicle = option;
      self.isImageDisabled = false;
      self.modelNotSelected = false;
      params.setUserVehicle(option);
    }

    // Update the packages available depending on the selected vehicle model
    function updatePackageDropdown(packages) {
      self.dropdownPackageTitle = packageLabel;
      self.packages = packages;
      self.packageDisabled = false;
      self.packageDescription = '';
    }

    // Function that is triggered when the user selects a package from the dropdown
    function selectPackage(e) {
      let selectedPackage = e.item.package;
      togglePackageDropdown();
      updateSelectedPackageInfo(selectedPackage);
      document.removeEventListener('click', closePackageDropdown);
      document.removeEventListener('keydown', closePackageDropdown);
    }

    // Update the information displayed in the "select a vehicle" section when a package change
    function updateSelectedPackageInfo(selectedPackage) {
      self.dropdownPackageTitle = selectedPackage.packageName;
      self.isPackageOpen = false;
      self.packageDescription = selectedPackage.packageDescription;
      self.vehicleImage = selectedPackage.packageImage;
      self.vehicleImageAlt = selectedPackage.packageImageAlt;
      self.selectedVehicle.modelId = selectedPackage.modelId;
      self.packageNotSelected = false;
      packageSelected = true;
      self.bus.trigger(self.bus.EVENTS.VEHICLE.SELECTED, self.selectedVehicle);
    }

    function goBack() {
      const prevStep = _.last(self.prevOptions);
      const currentStep = self.options;
      self.options = prevStep;
      self.prevOptions.pop();
      self.state = TAXONOMY.modelsState;

      if ((self.options === self.topOptions) || currentStep === prevStep || prevStep) {
        self.state = TAXONOMY.defaultState;
      }
      updateState();
    }

    function goTop() {
      self.options = self.topOptions;
      self.state = TAXONOMY.defaultState;
      updateState();
    }

    // Get the index of the tab based on the name of the vehicle, looking if it is a previous or current model
    function getTabIndex(taxonomy, modelYear, modelSeries) {
      let vehicleName = `${modelYear} ${modelSeries}`;
      let index;
      if (modelYear) {
        index = _.findIndex(taxonomy, function (item) {
          return _.find(item.Vehicles, function (vehicle) {
            return vehicle[TAXONOMY.name] === vehicleName;
          });
        });
      }

      return index >= 0 ? index : 0;
    }

    function updateTaxonomy(taxonomy) {
      let urlParams = params.userData().urlParams;
      let modelYear = urlParams ? urlParams.modelyear : null;
      let modelSeries = urlParams ? urlParams.vehiclemodelseries : null;
      let tabIndex = getTabIndex(taxonomy, modelYear, modelSeries);
      self.taxonomy = taxonomy;
      self.state = TAXONOMY.defaultState;

      getTabs(self.taxonomy, tabIndex);
      updateOptions(self.taxonomy);
      updateState();

      // If there is "modelSeries" in the url, try to select a vehicle model
      if (urlParams && modelSeries && !vehicleSelected) {
        selectMlpVehicle(urlParams);
        vehicleSelected = true;
      }
    }

    // Function to select a vehicle based on the url data
    function selectMlpVehicle(urlParams) {
      let mlpVehicle = findVehicleData(urlParams);
      updateSelectedModelInfo(mlpVehicle);

      // If there is "modelid" in the url, try to select a package
      if (urlParams.modelid) {
        let vehiclePackage = _.find(mlpVehicle.packages, packageItem => packageItem.modelId === urlParams.modelid);
        updateSelectedPackageInfo(vehiclePackage);
        self.bus.trigger(self.bus.EVENTS.STEPS.VEHICLE_UPDATED, { origin: 'vehicle' });
      }
      self.update();
    }

    function findVehicleData(urlParams) {
      let options = self.options;

      if (urlParams.modelyear) {
        let vehicleName = `${urlParams.modelyear} ${urlParams.vehiclemodelseries}`;
        return _.find(options, option => option.name === vehicleName);
      }

      return _.find(options, option => option.modelSeries === urlParams.vehiclemodelseries);
    }

    function updateVehicle() {
      self.vehicle = self.opts.vehicle;
      if (vehicleSelected && packageSelected) {
        self.bus.trigger(self.bus.EVENTS.STEPS.VEHICLE_UPDATED, { origin: 'vehicle' });
      }
      self.update();
    }

    function toggleModelDropdown() {
      self.isModelOpen = !self.isModelOpen;
      self.isPackageOpen = false;

      if (self.isModelOpen) {
        document.addEventListener('keydown', closeModelDropdown);
        document.addEventListener('click', closeModelDropdown);
      }
    }

    function togglePackageDropdown() {
      self.isPackageOpen = !self.isPackageOpen;
      self.isModelOpen = false;

      if (self.isPackageOpen) {
        document.addEventListener('keydown', closePackageDropdown);
        document.addEventListener('click', closePackageDropdown);
      }
    }

    // Function to mark the model or package fields when a model or package is not selected
    function markRequiredFields(userData) {
      // Validation for model dropdown
      if (!userData.modelYear || !userData.vehicleModelSeries) {
        self.modelNotSelected = true;
      }
      // Validation for package dropdown
      if (!userData.modelId) {
        self.packageNotSelected = true;
      }
      self.update();
    }

    function closeModelDropdown(e) {

      var modelDropdown = document.querySelector($modelDropdownId);
      var lastElement = modelDropdown.querySelector('.selector-dropdown-container').lastElementChild; // Get the las button in the list
      var lastButton = lastElement.querySelector('.selector-item');

      if ((e.key === 'Tab' && modelDropdown.contains(e.target) && lastButton === e.target)
        || !modelDropdown.contains(e.target)) {
        self.isModelOpen = false;
        self.isPackageOpen = false;
        self.update();
        document.removeEventListener('keydown', closeModelDropdown);
        document.removeEventListener('click', closeModelDropdown);
        e.preventDefault();
      }
    }

    function closePackageDropdown(e) {
      var packageDropdown = document.querySelector($packageDropdownId);
      var lastElement = packageDropdown.querySelector('.selector-dropdown-container').lastElementChild; // Get the las button in the list
      var lastButton = lastElement.querySelector('.selector-item');
      if ((e.key === 'Tab' && packageDropdown.contains(e.target) && lastButton === e.target)
        || !packageDropdown.contains(e.target)) {
        self.isModelOpen = false;
        self.isPackageOpen = false;
        self.update();
        document.removeEventListener('keydown', closePackageDropdown);
        document.removeEventListener('click', closePackageDropdown);
        e.preventDefault();
      }
    }

    self.selectTab = selectTab;
    self.selectModel = selectModel;
    self.selectPackage = selectPackage;
    self.goBack = goBack;
    self.goTop = goTop;
    self.toggleModelDropdown = toggleModelDropdown;
    self.togglePackageDropdown = togglePackageDropdown;

    self.bus.on(self.bus.EVENTS.VEHICLE.UPDATED, updateVehicle);
    // Trigger vehicle select update when Vehicle Container get's taxonomy form endpoint
    self.bus.on(self.bus.EVENTS.VEHICLE.TAXONOMYUPDATED, updateTaxonomy);
    self.bus.on(self.bus.EVENTS.VEHICLE.BACK_TO_MODELS, goBack);
    self.bus.on(self.bus.EVENTS.FORM.REQUIRED_FIELD, markRequiredFields);
});
